/**
 * Columnas para exportación de facturas.
 * Usadas en InvoicesExportModal y TaxesExportModal.
 */

export const INVOICES_EXPORT_COLUMN_IDS = [
    { id: 'id', labelKey: 'id', active: true },
    { id: 'file_name', labelKey: 'file-name', active: true },
    { id: 'type', labelKey: 'type', active: true },
    { id: 'subtype', labelKey: 'subtype', active: true },
    { id: 'identifier', labelKey: 'identifier', active: true },
    { id: 'description', labelKey: 'description', active: true },
    { id: 'date_emission', labelKey: 'date-emission', active: true },
    { id: 'date_operation', labelKey: 'date-operation', active: true },
    { id: 'date_expiration', labelKey: 'date-expiration', active: true },
    { id: 'date_payment', labelKey: 'date-payment', active: true },
    { id: 'amount_subtotal', labelKey: 'amount-subtotal', active: true },
    { id: 'amount_reimbursable', labelKey: 'amount-reimbursable', active: true },
    { id: 'amount_tax', labelKey: 'amount-tax', active: true },
    { id: 'amount_tax_unassigned', labelKey: 'amount-tax-unassigned', active: true },
    { id: 'currency', labelKey: 'currency', active: true },
    { id: 'is_validated', labelKey: 'is-validated', active: true },
    { id: 'is_reconciled', labelKey: 'is-reconciled', active: true },
    { id: 'status', labelKey: 'status', active: true },
    { id: 'contact_id', labelKey: 'contact-id', active: true, group: 'contact' },
    { id: 'contact_name', labelKey: 'contact-name', active: true, group: 'contact' },
    { id: 'contact_tax_id', labelKey: 'contact-tax-id', active: true, group: 'contact' },
    { id: 'contact_tax_id_type', labelKey: 'contact-tax-id-type', active: true, group: 'contact' },
    { id: 'contact_fiscal_address', labelKey: 'contact-fiscal-address', active: true, group: 'contact' },
    { id: 'contact_country', labelKey: 'contact-country', active: true, group: 'contact' },
    { id: 'taxonomies_tags', labelKey: 'taxonomies-tags', active: true },
    { id: 'amount_total', labelKey: 'amount-total', active: true },
];

/**
 * Genera las columnas de exportación de facturas con las traducciones aplicadas.
 * @param {function} t - Función de traducción de i18next
 * @returns {Array} Columnas con labels traducidos
 */
export function getInvoicesExportColumns(t) {
    return INVOICES_EXPORT_COLUMN_IDS.map((col) => ({
        id: col.id,
        label: t(col.labelKey),
        active: col.active,
        ...(col.group ? { group: col.group } : {}),
    }));
}

/**
 * Grupos de columnas para el selector.
 */
export const INVOICES_EXPORT_COLUMN_GROUPS_KEYS = [
    { id: 'contact', labelKey: 'contact-group' },
];

/**
 * Genera los grupos de columnas con las traducciones aplicadas.
 * @param {function} t - Función de traducción de i18next
 * @returns {Array} Grupos con labels traducidos
 */
export function getInvoicesExportColumnGroups(t) {
    return INVOICES_EXPORT_COLUMN_GROUPS_KEYS.map((group) => ({
        id: group.id,
        label: t(group.labelKey),
    }));
}

/**
 * Columnas que no pueden ser desactivadas.
 */
export const INVOICES_DISABLED_COLUMNS = [];
